module.exports = __webpack_public_path__ + "img/vv.a5e8db36.png";